import { useTranslation } from '@refinedev/core';
import { Breadcrumbs } from 'components/breadcrumbs';
import { useState } from 'react';
import { useEffect } from 'react';
import useWindowWidth from 'utills/InitWidthDevice';
import FormEditOrganization from '../formEdit';

const WPSOrganizationInformationEdit = () => {
  const windowWidth = useWindowWidth();
  const { translate } = useTranslation();
  const [token, setToken] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  const breadcrumbItems = [
    {
      label: translate('organization'),
      href: ''
    },
    {
      label: translate('information'),
      href: '/organization/info'
    },
    {
      label: translate('edit-information'),
      href: ''
    }
  ];

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);


  return (
    <div className="w-full">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />


      {
        token && token !== '' &&
        <div className='w-full flex items-center justify-center pt-[24px] pb-[100px]'>
          <FormEditOrganization
            translate={translate}
            isMobile={isMobile}
            token={token} />
        </div>
      }
    </div>
  )
};

export default WPSOrganizationInformationEdit;